import styled from 'styled-components';

export const TextLine = styled.p`
  margin-bottom: 0px;

`
